import { ApolloProvider } from '@apollo/client';
import createClient from './client';

const ManagerQueryProvider = ({ children }) => (
	<ApolloProvider client={createClient()}>{children}</ApolloProvider>
);

export { ManagerQueryProvider };
